import Container from "../../components/Container";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { IKanbanBoardRecord } from "../../lib/types";
import pb from "../../lib/pocketbase";
import { Link } from "react-router-dom";
import Button from "../../components/form/button";

export default function Kanban() {
    const [boards, setBoards] = useState<IKanbanBoardRecord[]>();
    const [isLoading, setIsLoading] = useState(true);

    async function load() {
        const kanbanBoards: IKanbanBoardRecord[] = await pb.collection("kanbanBoard").getFullList();
        setBoards(kanbanBoards);
        setIsLoading(false);
    }

    useEffect(() => {
        load();
    }, []);

    return (
        <>
            <Helmet>
                <title>ReinVB Studio — Kanban</title>
            </Helmet>
            <Container className="mt-4 md:mt-8 lg:mt-16">
                <div className="flex items-center gap-4">
                    <h2 className="text-3xl font-bold">Kanban.</h2>
                    <div className="rounded-lg bg-blue-500 px-2 py-1 text-xs font-medium text-white">Beta</div>
                </div>
                <div className="mt-8 flex flex-col gap-4">
                    {boards?.map((board) => {
                        return (
                            <Link to={`/studio/kanban/board/${board.id}`}>
                                <Button variant={"ghost"} size={"ghost"} className="flex w-full items-center justify-between rounded-lg border px-6 py-4 active:scale-95">
                                    {board.title}
                                </Button>
                            </Link>
                        );
                    })}
                </div>
            </Container>
        </>
    );
}
